import React from "react";
import { useSelector } from "react-redux";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";

import Summary from "./components/summary/Summary";
import MainContent from "./components/maincontent/MainContent";
import Footer from "./components/footer/Footer";
// import useSocket from "./hooks/socketConnect";
import { SignOutButton } from "../Auth/SignOutButton";

const Dashboard = () => {
  // const dispatch = useDispatch();
  const user = useSelector(state => state.authReducer.user);
  // useSocket(user, dispatch);

  return (
    <Container>
      <Container>
        <Navbar bg="primary" variant="dark" expand="lg" fixed="top">
          <Nav className="container-fluid">
            <Navbar.Brand>
              <i className="bi-telephone p-2"></i>
              EveryRing Dashboard
            </Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Nav.Item>
              <Navbar.Collapse
                id="basic-navbar-nav"
                className="justify-content-end"
              >
                <Navbar.Text>
                  {`Logged in as: ${user.name} (${user.email})`}
                </Navbar.Text>
                <Nav.Item>
                  <SignOutButton />
                </Nav.Item>
              </Navbar.Collapse>
            </Nav.Item>
          </Nav>
        </Navbar>
      </Container>
      <div className="container mb-3" style={{ marginTop: "110px" }}>
        <Summary />
      </div>
      <div className="container mt-3">
        <MainContent />
      </div>
      <div className="container mt-3">
        <Footer />
      </div>
    </Container>
  );
};

export default Dashboard;
